// extracted by mini-css-extract-plugin
module.exports = {"item":"_078fa95"};